module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1-og-bef1f9e930d9a148f10314c357546ded.jpg";